import React, {useState} from "react";
import { useTranslation } from 'react-i18next';
import ConfirmIconButton from "../../components/button/ConfirmIconButton";
import FunctionalTableComponent from "../../components/table/FunctionalTableComponent";
import columns from "./LineSimulationsTableConfig";
import fields from "../../components/common/SimpleDictionaryFormConfig";
import {useHistory} from "react-router-dom";
import {hasProductionFullAccess} from "../../helpers/jwt";

const LineSimulations = ({line, setLoader, setReload, reload}) => {

    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    let history = useHistory();

    const redirectToSimulation = (createdId) => {
        history.push("/production/" + line.id + "/simulation/" + createdId)
    }


    return (
        <>

            <ConfirmIconButton
                open={open}
                buttonsConf={{
                    save: t("common.continue")
                }}
                className={"mr-2"}
                variant={"outline-primary"}
                setOpen={setOpen}
                tooltip={t("menu.simulation")}
                icon={"fa-compass-drafting"}
                setLoader={setLoader}
                modalSize={"xl"}
                confirmTitle={t("menu.simulation")}
                modelChildren={
                    <FunctionalTableComponent
                        columns={columns}
                        shadow={false}
                        header={true}
                        setLoader={setLoader}
                        title={t("common.simulation_list")}
                        api={"lineInstallationSimulation?lineId=" + line?.id}
                        deleteApi={"lineInstallationSimulation"}
                        readOnly={!hasProductionFullAccess()}
                        removable={true}
                        editable={true}
                        details={!hasProductionFullAccess()}
                        editAction={redirectToSimulation}
                        detailsAction={redirectToSimulation}
                        width={12}
                        creationFields={fields(t)}
                        creationTitle={t("menu.new_simulation")}
                        fromModal={true}
                        pagination={false}
                        deleteModalTitle={t("common.delete_simulation")}
                        deleteModalDescription={t("confirmations.are_you_sure_delete_simulation")}
                        onCreated={redirectToSimulation}
                        beforeSave={(data) => {
                            data.lineId = line.id

                            return data;
                        }}
                    />


                }
            />


        </>
    );
};


export default LineSimulations;